// 📁 src/hooks/useContactsPeriodeDominante.js
import { useMemo } from "react";
import { detectPeriodeDominante } from "../utils/periodeDominante.js"
import { formatContact } from "../utils/formatContact.js";
import { logDev } from "../utils/logger.js";

export function useContactsPeriodeDominante(
  contacts = [], 
  { winningKey = null, onlyValidEmails = false, fallbackAll = false } = {}
) {

  return useMemo(() => {
    const safeContacts = Array.isArray(contacts) ? contacts : [];
    logDev("[useContactsPeriodeDominante] contacts bruts", safeContacts);

    // 1️⃣ Log la clé gagnante
    logDev("[useContactsPeriodeDominante] winningKey reçu", winningKey);

   // 2️⃣ Filtrer les contacts de cette période
    let filtres = [];
    if (winningKey) {
      // 🔎 On garde uniquement les contacts qui ont voté pour la période gagnante
      filtres = safeContacts.filter(c => 
        /*c.periodes?.some(p => p.periodeId === winningKey && Number(p.valeur) > 0)*/
        c.periodes?.some(p => p.periodeId?.toString() === winningKey?.toString() && Number(p.valeur) > 0)
      );
      // fallback si aucun votant trouvé
      if (fallbackAll && filtres.length === 0) {
        filtres = safeContacts;
      }
    } else if (fallbackAll) {
      filtres = safeContacts;
    }

    // ✅ Injecter les champs plats après filtrage
    const contactsDominante = filtres.map(c => formatContact(c, [ { _id: winningKey } ]));
    logDev("[useContactsPeriodeDominante] contactsDominante enrichis", contactsDominante);

    // 3️⃣ Extraire les emails
    let emails = filtres.map(c => c?.mail).filter(Boolean);
    if (onlyValidEmails) {
      emails = emails.filter(mail => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail));
    }

    // ✅ Somme des valeurs pour la période dominante
    const totalCombien = filtres.reduce((sum, c) => {
      const periode = c.periodes?.find(p => p.periodeId?.toString() === winningKey?.toString());
      const valeur = Number(periode?.valeur ?? c.combien ?? 0);
      return sum + valeur;
    }, 0);

    logDev("[useContactsPeriodeDominante] résultat", {
      winningKey,
      nbContacts: safeContacts.length,
      nbFiltres: filtres.length,
      totalCombien
    });

    // 🔹 Un seul log global
    logDev("[useContactsPeriodeDominante] résultat", {
      winningKey,
      nbContacts: safeContacts.length,
      nbFiltres: filtres.length,
      preview: filtres.slice(0, 3).map(c => ({
        nom: c.nom,
        periodes: c.periodes
      })),
      emailsPreview: emails.slice(0, 5),
      totalCombien
    });

    return {
      contactsDominante,
      emailsDominante: emails,
      winningKey,
      totalCombien,
      loading: false,
      info: {
        nbContacts: safeContacts.length,
        nbFiltres: filtres.length,
        periodeId: winningKey
      }
    };
  }, [contacts, winningKey, onlyValidEmails, fallbackAll]);
}